<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.72488 3.8334C2.39155 0.950065 6.73322 0.950065 7.39155 3.8334C7.78322 5.52507 6.70822 6.9584 5.77488 7.85007C5.09155 8.50007 4.01655 8.49173 3.33322 7.85007C2.40822 6.9584 1.33322 5.52507 1.72488 3.8334Z"
      :stroke="props.color" stroke-width="1.5" />
    <path
      d="M12.5583 13.8334C13.225 10.9501 17.5917 10.9501 18.2583 13.8334C18.65 15.5251 17.575 16.9584 16.6333 17.8501C15.95 18.5001 14.8667 18.4917 14.1833 17.8501C13.2417 16.9584 12.1667 15.5251 12.5583 13.8334Z"
      :stroke="props.color" stroke-width="1.5" />
    <path
      d="M9.99991 4.16699H12.2332C13.7749 4.16699 14.4916 6.07533 13.3332 7.09199L6.67491 12.917C5.51658 13.9253 6.23325 15.8337 7.76658 15.8337H9.99991"
      :stroke="props.color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4.57185 4.58366H4.58148" :stroke="props.color" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M15.4051 14.5837H15.4147" :stroke="props.color" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: 'rgb(var(--locumate-primary-color))',
  },
});
</script>